import util from '../util/util';
export default {
    // 轮播图数据
    section1: {
        // 图片地址
        link: util.get_img('news_banner.png'),
        // 标题
        title: '新闻资讯',
        // 描述
        description: '在这里了解有道智选，有关于我们的一切新闻资讯、产品信息、营销干货等。及时、准确、透明的信息，让我们距离更近'
    },
    // 新闻列表图块数据
    section2: {
        // 模块名称
        name: '新闻列表',
        // 卡片数据
    }
}


// WEBPACK FOOTER //
// ./src/data/news.js